module.exports = __webpack_public_path__ + "static/media/captcha.eb377134.svg";